import { QuestionnaireTemplate } from '@/tax-detail/models/questionnaire-template.model';

/* eslint-disable camelcase */
export class PersonalTaxSettings {
    id: number = -1;
    questionnaireAutomaticReminderDays: number | null = null;
    questionnaireTemplates: QuestionnaireTemplate[] = [];

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.questionnaireAutomaticReminderDays = data?.questionnaire_automatic_reminder_period
            ? parseInt(data?.questionnaire_automatic_reminder_period?.split(' ')[0])
            : null;
        this.questionnaireTemplates = data.all_questionnaire_templates.map((template: any) =>
            new QuestionnaireTemplate().deserialize(template),
        );
        return this;
    }

    serialize() {
        return {
            id: this.id,
            questionnaire_automatic_reminder_period:
                this.questionnaireAutomaticReminderDays === null ? null : `${this.questionnaireAutomaticReminderDays} 00:00:00`,
            questionnaire_templates: this.questionnaireTemplates.map((template) => template.serialize()),
        };
    }

    clone() {
        let res = new PersonalTaxSettings();
        res.id = this.id;
        res.questionnaireAutomaticReminderDays = this.questionnaireAutomaticReminderDays;
        res.questionnaireTemplates = this.questionnaireTemplates.map((template) => template.clone());
        return res;
    }
}
